export default __webpack_public_path__ + "static/media/num-03.39471fdb.svg";